export default {
  // Common
  common: {
    avatar: 'Avatar',
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    search: 'Search',
    reset: 'Reset',
    submit: 'Submit',
    back: 'Back',
    loading: 'Loading...',
    noData: 'No Data',
    success: 'Success',
    error: 'Error',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    action: 'Action',
    view: 'View',
    total: 'Total',
    items: 'items',
    language: 'Language',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    createUser: 'Create User',
    editUser: 'Edit User',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    deleteConfirm: 'Are you sure you want to delete?',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Failed to delete',
    createSuccess: 'Created successfully',
    createError: 'Failed to create',
    updateSuccess: 'Updated successfully',
    updateError: 'Failed to update',
    loadError: 'Failed to load',
    invalidId: 'Invalid ID',
    languageRequired: 'Please select language',
    noImage: 'No Image',
    upload: 'Upload',
    refresh: 'Refresh',
    refreshSuccess: 'Refreshed successfully',
    imageOnly: 'Only image files are allowed',
    imageSizeLimit: 'Image size cannot exceed 5MB',
    uploadSceneMissing: 'Please complete the required fields before uploading',
    totalItems: 'Total {total} items',
    previous: 'Previous',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    optional: 'Optional',
    saveError: 'Failed to save'
  },

  // Date Time Format
  datetime: {
    format: {
      full: 'yyyy-MM-dd HH:mm:ss',
      dateTime: 'yyyy-MM-dd HH:mm',
      date: 'yyyy-MM-dd',
      time: 'HH:mm:ss',
      monthDay: 'MM-dd',
      hourMinute: 'HH:mm'
    },
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    bigScreen: 'Big Screen',
    userManagement: 'User Management',
    roleManagement: 'Role Management',
    permissionManagement: 'Permission Management',
    departmentManagement: 'Department Management',
    systemManagement: 'System Management'
  },

  // Agricultural Screen
  agricultural: {
    title: 'Agricultural IoT Monitoring Dashboard',
    weatherSensor: 'Weather Sensor',
    soilSensor: 'Soil Sensor',
    deviceMap: 'Device Distribution Map',
    temperature: 'Temperature',
    humidity: 'Humidity',
    windSpeed: 'Wind Speed',
    windDirection: 'Wind Direction',
    rainfall: 'Rainfall',
    lightIntensity: 'Light Intensity',
    soilTemperature: 'Soil Temperature',
    soilHumidity: 'Soil Humidity',
    deviceStatus: 'Device Status',
    online: 'Online',
    offline: 'Offline',
    onlineDevices: 'Online Devices',
    offlineDevices: 'Offline Devices',
    systemStatus: 'System Status',
    normalOperation: 'Normal Operation',
    dataUpdate: 'Data Update',
    totalDevices: 'Total Devices',
    deviceNorthArea: 'Device A - North Farm Area',
    deviceSouthArea: 'Device B - South Farm Area',
    trendChart: '24-Hour Data Trend',
    anhui: 'Anhui Farm Equipment Distribution',
    location: 'Location',
    fullscreen: 'Toggle Fullscreen',
    lightTheme: 'Switch to Light Theme',
    darkTheme: 'Switch to Dark Theme',
    returnDashboard: 'Return to Dashboard'
  },

  // User Management
  user: {
    title: 'User Management',
    list: 'User List',
    create: 'Create User',
    edit: 'Edit User',
    username: 'Username',
    email: 'Email',
    phone: 'Phone',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    department: 'Department',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    createUser: 'Create User',
    editUser: 'Edit User',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    usernamePlaceholder: 'Please enter username',
    emailPlaceholder: 'Please enter email',
    phonePlaceholder: 'Please enter phone number',
    passwordPlaceholder: 'Please enter password',
    confirmPasswordPlaceholder: 'Please confirm password',
    statusPlaceholder: 'Please select status',
    departmentPlaceholder: 'Please select department',
    usernameRequired: 'Please enter username',
    emailRequired: 'Please enter email',
    statusRequired: 'Please select status',
    departmentRequired: 'Please select department',
    usernameLength: 'Username must be between 3 and 20 characters',
    emailInvalid: 'Please enter a valid email address',
    phoneInvalid: 'Please enter a valid phone number',
    passwordRequired: 'Please enter password',
    passwordLength: 'Password must be between 6 and 20 characters',
    confirmPasswordRequired: 'Please confirm password',
    confirmPasswordMismatch: 'The two passwords do not match',
    loadError: 'Failed to load user information',
    loadDepartmentError: 'Failed to load department list',
    updateSuccess: 'User updated successfully',
    updateError: 'Failed to update'
  },

  // Appraiser
  appraiser: {
    title: 'Appraiser Management',
    list: 'Appraiser List',
    edit: 'Edit Appraiser',
    appraiserId: 'Appraiser ID',
    customerId: 'User ID',
    realName: 'Name',
    realNamePlaceholder: 'Please enter name',
    realNameRequired: 'Please enter name',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone',
    phoneRequired: 'Please enter phone',
    phoneInvalid: 'Invalid phone format',
    weixin: 'WeChat',
    weixinPlaceholder: 'Please enter WeChat ID',
    titleLevel: 'Title Level',
    titleLevelPlaceholder: 'Please select',
    titleLevelIntern: 'Intern',
    titleLevelFormal: 'Formal',
    isWork: 'Service Enabled',
    isWorkPlaceholder: 'Please select',
    teacher: 'Teacher',
    teacherPlaceholder: 'Please select teacher',
    loadError: 'Failed to load appraiser list',
    loadDetailError: 'Failed to load appraiser detail',
    loadTeachersError: 'Failed to load teachers',
    updateSuccess: 'Updated successfully',
    updateError: 'Update failed'
  },

  // Sommelier Management
  sommelier: {
    title: 'Sommelier Management',
    list: 'Sommelier List',
    sommelierId: 'Sommelier ID',
    userId: 'User ID',
    realName: 'Name',
    realNamePlaceholder: 'Please enter name',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone',
    weixin: 'WeChat',
    gender: 'Gender',
    birthday: 'Birthday',
    address: 'Address',
    levelId: 'Level',
    isWork: 'Service Enabled',
    loadError: 'Failed to load sommelier list',
    upgradeTitle: 'Sommelier Level Change',
    levelPlaceholder: 'Please select level',
    levelRequired: 'Please select level',
    loadDetailError: 'Failed to load sommelier detail',
    upgradeSuccess: 'Level changed successfully',
    upgradeError: 'Failed to change level'
  },

  // Appraiser Application
  appraiserApplication: {
    title: 'Appraiser Application Review',
    list: 'Appraiser Application List',
    reviewButtonText: 'Review',
    review: 'Review Appraiser Application',
    nickname: 'Nickname',
    nicknamePlaceholder: 'Please enter nickname',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone',
    weixin: 'WeChat',
    city: 'City',
    cigarYear: 'Cigar Year',
    status: 'Review Status',
    statusPlaceholder: 'Please select review status',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    remark: 'Review Remark',
    remarkPlaceholder: 'Please enter review remark',
    approve: 'Approve',
    reject: 'Reject',
    createdAt: 'Application Time',
    auditedAt: 'Review Time',
    loadError: 'Failed to load application list',
    loadDetailError: 'Failed to load application detail',
    reviewSuccess: 'Review successful',
    reviewError: 'Review failed',
    approveConfirm: 'Are you sure to approve this application?',
    rejectConfirm: 'Are you sure to reject this application?',
    remarkRequired: 'Review remark is required',
    teacher: 'Teacher',
    teacherPlaceholder: 'Please select a teacher',
    teacherRequired: 'Teacher is required when approving'
  },

  sommelierApplication: {
    title: 'Sommelier Application Review',
    list: 'Sommelier Application List',
    reviewButtonText: 'Review',
    review: 'Review Sommelier Application',
    realName: 'Name',
    realNamePlaceholder: 'Please enter name',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone',
    weixin: 'WeChat',
    sex: 'Gender',
    sexMale: 'Male',
    sexFemale: 'Female',
    photoList: 'Photos',
    certificateList: 'Certificates',
    resumeList: 'Resume',
    provinceCode: 'Province Code',
    cityCode: 'City Code',
    districtCode: 'District Code',
    address: 'Address',
    status: 'Review Status',
    statusPlaceholder: 'Please select review status',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    remark: 'Review Remark',
    remarkPlaceholder: 'Please enter review remark (required when rejecting)',
    approve: 'Approve',
    reject: 'Reject',
    createdAt: 'Application Time',
    auditedAt: 'Review Time',
    loadError: 'Failed to load application list',
    loadDetailError: 'Failed to load application detail',
    reviewSuccess: 'Review successful',
    reviewError: 'Review failed',
    approveConfirm: 'Are you sure to approve this application?',
    rejectConfirm: 'Are you sure to reject this application?',
    remarkRequired: 'Review remark is required when rejecting',
    level: 'Sommelier Level',
    levelPlaceholder: 'Please select sommelier level',
    levelRequired: 'Sommelier level is required when approving'
  },

  // Cigar Brand Management
  // Brand category management
  brandCategory: {
    title: 'Brand Categories',
    all: 'All',
    name: 'Name',
    namePlaceholder: 'Please enter category name',
    nameRequired: 'Please enter category name',
    parent: 'Parent Category',
    parentPlaceholder: 'Leave empty to create a top-level category',
    description: 'Description',
    descriptionPlaceholder: 'Please enter category description',
    sortOrder: 'Sort Order',
    sortOrderPlaceholder: 'Enter sort order (lower values appear first)',
    addTitle: 'Add Category',
    addChild: 'Add Subcategory',
    addChildTitle: 'Add Subcategory',
    editTitle: 'Edit Category',
    createSuccess: 'Category created successfully',
    updateSuccess: 'Category updated successfully',
    updateError: 'Failed to update category',
    deleteConfirm: 'Are you sure to delete this category? It cannot be deleted while it has subcategories or is referenced by brands.'
  },

  cigarBrand: {
    title: 'Cigar Brand Management',
    list: 'Brand List',
    create: 'Create Brand',
    edit: 'Edit Brand',
    detail: 'Brand Detail',
    brandId: 'Brand ID',
    sortOrder: 'Sort Order',
    sortOrderPlaceholder: 'Please enter sort order',
    code: 'Brand Code',
    logo: 'Brand Logo',
    codeRequiredBeforeLogo: 'Brand code (English slug) is the OSS directory cigar_brands/{slug}/. Fill in the brand code before uploading the logo.',
    serie: 'Serie',
    seriePlaceholder: 'Please select series (multiple selection)',
    name: 'Brand Name',
    nameCn: 'Brand Name (Chinese)',
    nameEn: 'Brand Name (English)',
    description: 'Description',
    descriptionCn: 'Description (Chinese)',
    descriptionEn: 'Description (English)',
    brandCategory: 'Brand category',
    brandCategoryPlaceholder: 'Select brand category',
    tabAll: 'All',
    country: 'Country',
    countryCn: 'Country (Chinese)',
    countryEn: 'Country (English)',
    factoryName: 'Factory Name',
    factoryNamePlaceholder: 'Please enter factory name',
    genericName: 'Generic Name',
    genericNamePlaceholder: 'Please enter generic name',
    status: 'Status',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    languageId: 'Language',
    languageCn: 'Chinese',
    languageEn: 'English',
    searchPlaceholder: 'Search brand name or code',
    codePlaceholder: 'Please enter brand code',
    namePlaceholder: 'Please enter brand name',
    descriptionPlaceholder: 'Please enter brand description',
    countryPlaceholder: 'Please select country',
    codeRequired: 'Please enter brand code',
    nameRequired: 'Please enter brand name',
    countryRequired: 'Please select country',
    countryCodeLength: 'Country code cannot exceed 3 characters',
    createSuccess: 'Brand created successfully',
    createError: 'Failed to create brand',
    updateSuccess: 'Brand updated successfully',
    updateError: 'Failed to update brand',
    categoryUpdateSuccess: 'Brand category updated',
    dragToCategoryHint: 'Drag a brand row onto a category node to change its category',
    deleteSuccess: 'Brand deleted successfully',
    deleteError: 'Failed to delete brand',
    deleteConfirm: 'Are you sure you want to delete this brand?',
    fetchError: 'Failed to fetch brand list',
    fetchDetailError: 'Failed to fetch brand details',
    uploadLogo: 'Upload Logo',
    multiLanguage: 'Multi-language Settings',
    basicInfo: 'Basic Information',
    languageVersionExtra: 'Switch language to edit the name and description of that language version. Code, category, logo and series are shared across languages.',
    switchLanguageConfirmTitle: 'Switch language version',
    switchLanguageConfirmContent: 'There are unsaved changes in the current language version. Switching will discard them. Continue?',
    switchLanguageConfirmOk: 'Switch anyway'
  },

  cigarRingBand: {
    title: 'Cigar Ring Band Management',
    list: 'Ring Band List',
    create: 'Create Ring Band',
    edit: 'Edit Ring Band',
    tabsBasic: 'Basic Information',
    tabsRing: 'Ring Band Information',
    add: 'Add Ring Band',
    ringName: 'Ring Band Name',
    ringNamePlaceholder: 'Please enter ring band name',
    ringNameRequired: 'Please enter ring band name',
    image: 'Ring Band Image',
    imageRequired: 'Please upload a ring band image',
    periodDesc: 'Period Description',
    periodDescPlaceholder: 'Please enter period description, e.g. 2016-present',
    startYear: 'Start Year',
    startYearPlaceholder: 'Please enter start year',
    endYear: 'End Year',
    endYearPlaceholder: 'Please enter end year, 9999 means present',
    present: 'Present',
    yearRangeError: 'End year cannot be earlier than start year',
    brandId: 'Brand',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    createSuccess: 'Ring band created successfully',
    createError: 'Failed to create ring band',
    updateSuccess: 'Ring band updated successfully',
    updateError: 'Failed to update ring band',
    deleteSuccess: 'Ring band deleted successfully',
    deleteError: 'Failed to delete ring band',
    deleteConfirm: 'Are you sure you want to delete this ring band?',
    loadError: 'Failed to load ring band data'
  },

  // Cigar Serie Management
  cigarSerie: {
    title: 'Cigar Serie Management',
    list: 'Serie List',
    create: 'Create Serie',
    edit: 'Edit Serie',
    detail: 'Serie Detail',
    serieId: 'Serie',
    brandId: 'Brand',
    brand: 'Brand',
    code: 'Serie Code',
    name: 'Serie Name',
    description: 'Description',
    sortOrder: 'Sort Order',
    brandPlaceholder: 'Please select brand',
    codePlaceholder: 'Please enter serie code',
    namePlaceholder: 'Please enter serie name',
    descriptionPlaceholder: 'Please enter serie description',
    sortOrderPlaceholder: 'Please enter sort order',
    brandRequired: 'Please select brand',
    codeRequired: 'Please enter serie code',
    nameRequired: 'Please enter serie name',
    codeLength: 'Serie code must be between 2-64 characters',
    nameLength: 'Serie name must be between 2-255 characters',
    createSuccess: 'Serie created successfully',
    createError: 'Failed to create serie',
    updateSuccess: 'Serie updated successfully',
    updateError: 'Failed to update serie',
    deleteSuccess: 'Serie deleted successfully',
    deleteError: 'Failed to delete serie',
    deleteConfirm: 'Are you sure you want to delete this serie?',
    fetchError: 'Failed to fetch serie list',
    fetchDetailError: 'Failed to fetch serie details',
    loadError: 'Failed to load serie data'
  },

  // Cigar Common Name Management
  cigarCommonName: {
    title: 'Cigar Common Name Management',
    list: 'Common Name List',
    create: 'Create Common Name',
    edit: 'Edit Common Name',
    detail: 'Common Name Detail',
    name: 'Common Name',
    sortOrder: 'Sort Order',
    namePlaceholder: 'Please enter the common name',
    sortOrderPlaceholder: 'Please enter sort order (smaller comes first)',
    nameRequired: 'Please enter the common name',
    nameLength: 'Common name length should be between 1 and 255 characters',
    createSuccess: 'Common name created successfully',
    createError: 'Failed to create common name',
    updateSuccess: 'Common name updated successfully',
    updateError: 'Failed to update common name',
    deleteSuccess: 'Common name deleted successfully',
    deleteError: 'Failed to delete common name',
    deleteConfirm: 'Are you sure you want to delete this common name? It cannot be deleted while still referenced by a cigar.',
    loadError: 'Failed to load common name data'
  },

  // Cigar Factory Vitola Management
  cigarFactoryVitola: {
    title: 'Cigar Factory Vitola Management',
    list: 'Factory Vitola List',
    create: 'Create Factory Vitola',
    edit: 'Edit Factory Vitola',
    detail: 'Factory Vitola Detail',
    name: 'Factory Vitola',
    sortOrder: 'Sort Order',
    namePlaceholder: 'Please enter the factory vitola',
    sortOrderPlaceholder: 'Please enter sort order (smaller comes first)',
    nameRequired: 'Please enter the factory vitola',
    nameLength: 'Factory vitola length should be between 1 and 255 characters',
    createSuccess: 'Factory vitola created successfully',
    createError: 'Failed to create factory vitola',
    updateSuccess: 'Factory vitola updated successfully',
    updateError: 'Failed to update factory vitola',
    deleteSuccess: 'Factory vitola deleted successfully',
    deleteError: 'Failed to delete factory vitola',
    deleteConfirm: 'Are you sure you want to delete this factory vitola? It cannot be deleted while still referenced by a cigar.',
    loadError: 'Failed to load factory vitola data'
  },

  // Cigar Management
  cigar: {
    title: 'Cigar Management',
    list: 'Cigar List',
    create: 'Create Cigar',
    edit: 'Edit Cigar',
    detail: 'Cigar Detail',
    cigarId: 'Cigar ID',
    brand: 'Brand',
    brandPlaceholder: 'Please select brand',
    serie: 'Serie',
    serieId: 'Serie ID',
    name: 'Cigar Name',
    /** List page column/search label */
    listName: 'Cigar Name',
    code: 'Product Code',
    /** List page SKU column: maps to cj_cigar.code */
    sku: 'SKU',
    skuPlaceholder: 'Enter SKU',
    price: 'Price',
    currency: 'Currency',
    length: 'Length',
    ringGauge: 'Ring Gauge',
    weight: 'Weight',
    defaultPackId: 'Default Pack ID',
    strength: 'Strength',
    sortOrder: 'Sort Order',
    mainImage: 'Main Image',
    image: 'Image',
    filterTreeAll: 'All Brands',
    serieRelationDeleteConfirm: 'Remove this series from the brand? Only the association is removed; the series itself is kept.',
    serieRelationDeleteSuccess: 'Series association removed',
    serieRelationDeleteError: 'Failed to remove series association',
    dragImageHint: 'Drag to upload',
    dragImageOnly: 'Only image files are supported',
    dragImageUploadSuccess: 'Image appended successfully',
    dragImageUploadFailed: 'Failed to append image',
    startYear: 'Start Year',
    endYear: 'End Year',
    releaseYear: 'Release Year',
    status: 'Status',
    factoryName: 'Factory Name',
    commonName: 'Common Name',
    region: 'Region',
    regionPlaceholder: 'Please select region',
    description: 'Description',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    statusInProduction: 'In Production',
    statusDiscontinued: 'Discontinued',
    namePlaceholder: 'Please enter cigar name',
    codePlaceholder: 'Please enter product code',
    serieIdPlaceholder: 'Please enter serie ID',
    pricePlaceholder: 'Please enter price',
    currencyPlaceholder: 'e.g. CNY, USD',
    lengthPlaceholder: 'Please enter length(mm)',
    ringGaugePlaceholder: 'Please enter ring gauge',
    weightPlaceholder: 'Please enter weight(g)',
    defaultPackIdPlaceholder: 'Please enter default pack ID',
    strengthPlaceholder: 'Please enter strength(0-10)',
    sortOrderPlaceholder: 'Please enter sort order (smaller first)',
    statusPlaceholder: 'Please select status',
    factoryNamePlaceholder: 'Please enter factory name',
    commonNamePlaceholder: 'Please enter common name',
    descriptionPlaceholder: 'Please enter description',
    nameRequired: 'Please enter cigar name',
    codeRequired: 'Please enter product code',
    codeLength: 'Product code must be between 2-64 characters',
    createSuccess: 'Cigar created successfully',
    createError: 'Failed to create cigar',
    updateSuccess: 'Cigar updated successfully',
    updateError: 'Failed to update cigar',
    deleteSuccess: 'Cigar deleted successfully',
    deleteError: 'Failed to delete cigar',
    deleteConfirm: 'Are you sure you want to delete this cigar?',
    fetchError: 'Failed to fetch cigar list',
    fetchDetailError: 'Failed to fetch cigar details',
    loadError: 'Failed to load cigar data',
    // Section card titles on create/edit pages
    sectionBasicInfo: 'Basic Info',
    sectionSpecs: 'Specifications',
    sectionDescription: 'Description',
    yearInfo: 'Year Info',
    // Semantic image slots (order matches the import pipeline "file number -> image type" convention)
    images: 'Cigar Images',
    imageSlotSerieLogo: 'Serie Logo',
    imageSlotOpenBox: 'Open Box Photo',
    imageSlotCloseup: 'Single Cigar Closeup',
    imageSlotBox: 'Closed Box Photo',
    imageSlotOthers: 'Other Photos'
  },

  // Cigar Excel Import
  cigarImport: {
    title: 'Cigar Data Import',
    taskList: 'Import Tasks',
    upload: 'Upload Excel',
    chooseFile: 'Click or drag .xlsx file to upload',
    supportXlsx: 'Only .xlsx format is supported',
    sizeLimit: 'Single file up to {size}MB',
    onlyXlsx: 'Only .xlsx files are allowed',
    uploadSuccess: 'Upload success, task queued',
    uploadFailed: 'Upload failed',
    taskId: 'Task ID',
    fileName: 'File Name',
    status: 'Status',
    pending: 'Pending',
    running: 'Running',
    success: 'Success',
    failed: 'Failed',
    cancelled: 'Cancelled',
    cancelTask: 'Cancel Task',
    cancelConfirm: 'Cancel this import task? Rows already written cannot be rolled back.',
    cancelSuccess: 'Task cancelled',
    cancelFailed: 'Failed to cancel task',
    totalRows: 'Total Rows',
    processedRows: 'Processed',
    successRows: 'Success',
    skippedRows: 'Skipped',
    failedRows: 'Failed',
    errorDetail: 'Error Details',
    row: 'Row',
    column: 'Column',
    message: 'Message',
    viewProgress: 'View Progress',
    createdAt: 'Created At',
    brandType: 'Brand Type',
    brandTypePlaceholder: 'Please select brand type',
    brandTypeRequired: 'Please select brand type first',
    brandTypeChina: 'China',
    brandTypeCuba: 'Cuba',
    brandTypeNonCuban: 'Non-Cuban',
    stepBrandType: 'Brand Type',
    stepBrandTypeDesc: 'Choose the cigar brand category for this import',
    stepFile: 'Upload File',
    stepFileDesc: 'Choose the Excel file (.xlsx) to import',
    stepProgress: 'Progress',
    prev: 'Previous',
    next: 'Next',
    startNew: 'Import New File',
    subtitle: 'Quickly import cigar library data via Excel templates. Please pick the matching template.',
    catChinaTitle: 'Chinese Cigars',
    catChinaDesc: 'Supports Great Wall, Wang Guan and other domestic cigar data',
    catCubaTitle: 'Cuban Cigars',
    catCubaDesc: 'Supports Cohiba, Montecristo and other Cuban cigar data',
    catNonCubanTitle: 'Non-Cuban Cigars',
    catNonCubanDesc: 'Supports Davidoff, Padron and other non-Cuban cigar data',
    downloadTemplate: 'Download Template',
    downloadTemplateDisabled: 'Template download is not available yet. Please contact the administrator.',
    uploadHint: 'Click or drag a file here to upload',
    uploadHintSub: 'Supports .xlsx files, up to 5000 rows per import',
    // Per-brand-type template hints shown before upload to help users verify file structure
    templateCubanHint: '25 columns: Brand / Serie / Region / Release / SKU / Factory / Common name / Size / Price / Description',
    templateChinaHint: '22 columns: Brand / Serie / Release / Cigar name / SKU / Factory / Common name / Size / Weight / Price (CNY) / Description',
    templateNonCubanHint: '23 columns: Brand / Serie / Cigar / SKU / Common name / Length / Ring gauge / Wrapper / Binder / Filler / Grade / Blender / Origin',
    wrongCategoryForNonCubanFile: 'This file looks like a non-Cuban template. Select "Non-Cuban Cigars" before uploading.'
  },

  // Cigar Identify Image Rule Management
  cigarIdentify: {
    title: 'Cigar Identify Rules',
    list: 'Rule List',
    create: 'Create Rule',
    edit: 'Edit Rule',
    ruleId: 'Rule ID',
    code: 'Rule Code',
    codePlaceholder: 'Please enter rule code',
    codeRequired: 'Please enter rule code',
    name: 'Rule Name',
    namePlaceholder: 'Please enter rule name',
    exampleImage: 'Example Image',
    requiredLevel: 'Required Level',
    requiredLevelPlaceholder: 'Please select required level',
    requiredLevelRequired: 'Required level is required',
    requiredLevelOptional: 'Optional',
    requiredLevelRequiredValue: 'Required',
    requiredLevelRecommended: 'Recommended',
    description: 'Description',
    descriptionPlaceholder: 'Please enter description',
    enabled: 'Enabled',
    sortOrder: 'Sort Order',
    sortOrderPlaceholder: 'Please enter sort order',
    createdAt: 'Created At',
    searchPlaceholder: 'Search rule name',
    loadError: 'Failed to load rule list',
    createSuccess: 'Rule created successfully',
    createError: 'Failed to create rule',
    updateSuccess: 'Rule updated successfully',
    updateError: 'Failed to update rule'
  },

  // Virtual Item Management
  virtualItem: {
    title: 'Virtual Item Management',
    list: 'Item List',
    create: 'Create Item',
    edit: 'Edit Item',
    itemId: 'Item ID',
    code: 'Item Code',
    itemType: 'Item Type',
    name: 'Item Name',
    icon: 'Icon',
    defaultDurationDays: 'Default Duration (Days)',
    status: 'Status',
    itemTypeAvatarFrame: 'Avatar Frame',
    itemTypeCommentBg: 'Comment Background',
    itemTypeEmoji: 'Emoji',
    codePlaceholder: 'Please enter item code',
    namePlaceholder: 'Please enter item name',
    itemTypePlaceholder: 'Please select item type',
    imageIdPlaceholder: 'Please enter icon attachment ID',
    defaultDurationDaysPlaceholder: 'Please enter default duration days',
    codeRequired: 'Please enter item code',
    nameRequired: 'Please enter item name',
    itemTypeRequired: 'Please select item type',
    defaultDurationDaysRequired: 'Please enter default duration',
    defaultDurationDaysMin: 'Default duration must be greater than 0',
    statusRequired: 'Please select status',
    createSuccess: 'Item created successfully',
    createError: 'Failed to create item',
    updateSuccess: 'Item updated successfully',
    updateError: 'Failed to update item',
    deleteSuccess: 'Item deleted successfully',
    deleteError: 'Failed to delete item',
    deleteConfirm: 'Are you sure you want to delete this item?',
    loadError: 'Failed to load item list'
  },

  // Wishlist Management
  wishlist: {
    title: 'Wishlist Management',
    customer: 'Customer',
    customerId: 'Customer ID',
    customerIdPlaceholder: 'Enter customer ID',
    target: 'Wishlist Target',
    targetId: 'Target ID',
    targetIdPlaceholder: 'Enter target ID',
    type: 'Type',
    typePlaceholder: 'Please select type',
    typeProduct: 'Product',
    typeCigar: 'Cigar',
    sortOrder: 'Sort',
    statusPlaceholder: 'Please select status',
    statusActive: 'Active',
    statusCancelled: 'Cancelled',
    cancelAt: 'Cancel Time',
    saveSort: 'Save Sort',
    restore: 'Restore',
    cancelWishlist: 'Cancel',
    cancelConfirm: 'Are you sure you want to cancel this wishlist record?',
    loadError: 'Failed to load wishlist',
    updateSuccess: 'Wishlist updated successfully',
    updateError: 'Failed to update wishlist',
    restoreSuccess: 'Wishlist restored successfully',
    cancelSuccess: 'Wishlist cancelled successfully',
    cancelError: 'Failed to cancel wishlist'
  },

  // Question Management
  question: {
    headerTitle: 'Question Management',
    title: 'Title',
    list: 'Question List',
    create: 'Create Question',
    edit: 'Edit Question',
    titlePlaceholder: 'Please enter question',
    titleRequired: 'Please enter question',
    type: 'Question Type',
    typePlaceholder: 'Please select question type',
    typeRequired: 'Please select question type',
    typeSingle: 'Single Choice',
    typeMulti: 'Multiple Choice',
    typeJudge: 'True/False',
    difficulty: 'Difficulty',
    difficultyRequired: 'Please select difficulty',
    analysis: 'Analysis',
    analysisPlaceholder: 'Please enter analysis',
    options: 'Options',
    optionKeyPlaceholder: 'Option Key',
    optionContentPlaceholder: 'Please enter option content',
    optionContentRequired: 'Option content cannot be empty',
    isCorrect: 'Correct Answer',
    addOption: 'Add Option',
    optionsMinRequired: 'At least 2 options are required',
    atLeastOneCorrectRequired: 'At least one correct answer is required',
    optionKeyDuplicate: 'Option keys cannot be duplicated',
    true: 'True',
    false: 'False',
    createSuccess: 'Question created successfully',
    createError: 'Failed to create question',
    updateSuccess: 'Question updated successfully',
    updateError: 'Failed to update question',
    loadError: 'Failed to load question',
    notFound: 'Question not found'
  },

  // Topic management
  topic: {
    headerTitle: 'Topic Management',
    name: 'Name',
    create: 'Create Topic',
    edit: 'Edit Topic',
    namePlaceholder: 'Please enter topic name',
    nameRequired: 'Please enter topic name',
    nameMaxLength: 'Name cannot exceed 255 characters',
    type: 'Type',
    typePlaceholder: 'Please select type',
    typeRequired: 'Please select type',
    typePost: 'Post',
    typeWiki: 'Wiki',
    hotTopic: 'Hot Topic',
    hotTopicYes: 'Hot',
    hotTopicNo: 'Normal',
    discussNum: 'Discussion Count',
    discussNumPlaceholder: 'Please enter discussion count',
    enabled: 'Enabled',
    enabledYes: 'Enabled',
    enabledNo: 'Disabled',
    yes: 'Yes',
    no: 'No',
    createSuccess: 'Topic created successfully',
    createError: 'Failed to create topic',
    updateSuccess: 'Topic updated successfully',
    updateError: 'Failed to update topic',
    loadError: 'Failed to load topic list',
    loadDetailError: 'Failed to load topic',
    notFound: 'Topic not found',
    deleteError: 'Failed to delete topic'
  },

  // Option Management
  option: {
    title: 'Product Options',
    create: 'Create Option',
    edit: 'Edit Option',
    update: 'Update Option',
    optionId: 'Option ID',
    name: 'Option Name',
    type: 'Option Type',
    values: 'Option Values',
    sortOrder: 'Sort Order',
    searchPlaceholder: 'Search option name',
    namePlaceholder: 'Please enter option name',
    typePlaceholder: 'Please select option type',
    sortOrderPlaceholder: 'Please enter sort order',
    typeSelect: 'Select',
    typeRadio: 'Radio',
    typeCheckbox: 'Checkbox',
    addValue: 'Add Value',
    valueName: 'Value Name',
    valueImage: 'Value Image',
    noValues: 'No values, click "Add Value" to add option values',
    nameRequired: 'Please enter option name',
    typeRequired: 'Please select option type',
    sortOrderRequired: 'Please enter sort order',
    createSuccess: 'Option created successfully',
    createError: 'Failed to create option',
    updateSuccess: 'Option updated successfully',
    updateError: 'Failed to update option',
    deleteSuccess: 'Option deleted successfully',
    deleteError: 'Failed to delete option',
    deleteConfirm: 'Are you sure you want to delete this option?',
    loadError: 'Failed to load option data'
  },

  // Note Management
  note: {
    title: 'Note Management',
    list: 'Note List',
    create: 'Create Note',
    edit: 'Edit Note',
    detail: 'Note Detail',
    id: 'ID',
    userId: 'User ID',
    noteTitle: 'Title',
    type: 'Type',
    category: 'Category',
    description: 'Content',
    location: 'Location',
    longitude: 'Longitude',
    latitude: 'Latitude',
    status: 'Status',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    typeNormal: 'Image/Text',
    typeVideo: 'Video',
    category0: 'Recommend',
    category1: 'Identify',
    category2: 'Appointment',
    category3: 'Help',
    category4: 'Offline',
    statusValid: 'Valid',
    statusInvalid: 'Invalid',
    searchTitle: 'Search Title',
    selectType: 'Note Type',
    selectCategory: 'Note Category',
    userIdPlaceholder: 'Please enter user ID',
    titlePlaceholder: 'Please enter note title',
    descriptionPlaceholder: 'Please enter note content',
    locationPlaceholder: 'Please enter location',
    longitudePlaceholder: 'Please enter longitude',
    latitudePlaceholder: 'Please enter latitude',
    userIdRequired: 'Please enter user ID',
    titleRequired: 'Please enter title',
    typeRequired: 'Please select type',
    categoryRequired: 'Please select category',
    descriptionRequired: 'Please enter content',
    locationRequired: 'Please enter location',
    statusRequired: 'Please select status',
    titleMaxLength: 'Title cannot exceed 255 characters',
    locationMaxLength: 'Location cannot exceed 255 characters',
    createSuccess: 'Created successfully',
    createError: 'Failed to create',
    updateSuccess: 'Updated successfully',
    updateError: 'Failed to update',
    deleteSuccess: 'Deleted successfully',
    deleteError: 'Failed to delete',
    deleteConfirm: 'Are you sure you want to delete this note?',
    fetchError: 'Failed to fetch note list',
    fetchDetailError: 'Failed to fetch note detail'
  },

  // Data Dictionary Management
  dict: {
    title: 'Data Dictionary Management',
    list: 'Dictionary List',
    create: 'Create Dictionary',
    edit: 'Edit Dictionary',
    code: 'Code',
    name: 'Name',
    description: 'Description',
    searchPlaceholder: 'Please enter search content',
    codePlaceholder: 'Please enter dictionary code',
    namePlaceholder: 'Please enter dictionary name',
    descriptionPlaceholder: 'Please enter dictionary description',
    view: 'View',
    delete: 'Delete',
    codeRequired: 'Please enter dictionary code',
    nameRequired: 'Please enter dictionary name',
    basicInfo: 'Basic Information',
    dictItems: 'Data Dictionary',
    nextStep: 'Next Step',
    prevStep: 'Previous Step',
    addNew: 'Add New',
    valueCode: 'Value Code',
    valueName: 'Value Name',
    valueCodePlaceholder: 'Please enter',
    valueNamePlaceholder: 'Please enter',
    moveUp: 'Move Up',
    moveDown: 'Move Down',
    itemValidationError: 'Please fill in complete dictionary item information',
    createSuccess: 'Dictionary created successfully',
    createError: 'Failed to create dictionary',
    updateSuccess: 'Dictionary updated successfully',
    updateError: 'Failed to update dictionary',
    deleteSuccess: 'Dictionary deleted successfully',
    deleteError: 'Failed to delete dictionary',
    deleteConfirm: 'Are you sure you want to delete this dictionary?',
    fetchError: 'Failed to fetch dictionary list',
    fetchDetailError: 'Failed to fetch dictionary detail'
  },

  // Role Management
  role: {
    title: 'Role Management',
    list: 'Role List',
    create: 'Create Role',
    edit: 'Edit Role',
    name: 'Role Name',
    code: 'Role Code',
    description: 'Description',
    permissions: 'Permissions',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchPlaceholder: 'Search roles...',
    statusPlaceholder: 'Status',
    namePlaceholder: 'Please enter role name',
    codePlaceholder: 'Please enter role code',
    descriptionPlaceholder: 'Please enter description',
    nameRequired: 'Please enter role name',
    nameLength: 'Role name must be between 2 and 50 characters',
    codeRequired: 'Please enter role code',
    codeInvalid: 'Role code can only contain uppercase letters and underscores',
    createSuccess: 'Role created successfully',
    createError: 'Failed to create role',
    updateSuccess: 'Role updated successfully',
    updateError: 'Failed to update role',
    deleteSuccess: 'Role deleted successfully',
    deleteError: 'Failed to delete role',
    deleteConfirm: 'Are you sure you want to delete this role?',
    loadError: 'Failed to load roles',
    assignPermissions: 'Assign Permissions',
    permissionsTitle: 'Assign Permissions',
    user: 'User',
    assignRoles: 'Assign Roles',
    rolesTitle: 'Assign Roles',
    assignPermissionsPage: {
      title: 'Assign Permissions to Role',
      saveChanges: 'Save Changes',
      resourceGroups: 'Resource Groups',
      modulePermissions: '{name} Permissions',
      resourcePrefix: 'Resource: {code}',
      direct: 'Direct',
      inherited: 'Inherited',
      selectAll: 'Select All',
      clearAll: 'Clear All',
      expandAll: 'Expand All',
      collapseAll: 'Collapse All',
      filterPlaceholder: 'Filter permissions...',
      selectedCount: '{checked} / {total} selected',
      empty: 'No permissions available',
      filterEmpty: 'No matching permissions',
      selectModuleHint: 'Select a resource module from the left panel',
      loadError: 'Failed to load permission data',
      saveSuccess: 'Role permissions saved successfully',
      saveError: 'Failed to save role permissions',
      invalidRole: 'Invalid role ID',
      columnName: 'Permission Name',
      columnCode: 'Code / Action',
      columnType: 'Type',
      columnDescription: 'Description'
    }
  },

  // Permission Management
  permission: {
    title: 'Permission Management',
    list: 'Permission List',
    create: 'Create Permission',
    edit: 'Edit Permission',
    name: 'Permission Name',
    code: 'Permission Code',
    description: 'Description',
    resource: 'Resource Name',
    resourceCode: 'Resource Code',
    action: 'Action',
    enabled: 'Enabled',
    disabled: 'Disabled',
    searchPlaceholder: 'Search permissions...',
    resourcePlaceholder: 'Resource',
    statusPlaceholder: 'Status',
    namePlaceholder: 'Please enter permission name',
    codePlaceholder: 'Please enter permission code',
    descriptionPlaceholder: 'Please enter description',
    resourcePlaceholderInput: 'Please enter resource name',
    resourceCodePlaceholder: 'Please enter or select resource code',
    actionPlaceholder: 'Please enter action',
    nameRequired: 'Please enter permission name',
    nameLength: 'Permission name must be 2 to 50 characters',
    codeRequired: 'Please enter permission code',
    resourceRequired: 'Please enter resource name',
    resourceCodeRequired: 'Please enter resource code',
    actionRequired: 'Please enter action',
    createSuccess: 'Permission created successfully',
    createError: 'Failed to create permission',
    updateSuccess: 'Permission updated successfully',
    updateError: 'Failed to update permission',
    deleteSuccess: 'Permission deleted successfully',
    deleteError: 'Failed to delete permission',
    deleteConfirm: 'Are you sure you want to delete this permission?',
    loadError: 'Failed to load permissions'
  },

  // Policy Management
  policy: {
    title: 'Policy Management',
    list: 'Policy List',
    create: 'Create Policy',
    edit: 'Edit Policy',
    titleLabel: 'Title',
    code: 'Code',
    accessUrl: 'Access URL',
    copyUrl: 'Copy access URL',
    copySuccess: 'Access URL copied to clipboard',
    copyError: 'Copy failed, please copy manually',
    content: 'Content',
    titlePlaceholder: 'Please enter title',
    codePlaceholder: 'Please enter code',
    contentPlaceholder: 'Please enter content',
    titleRequired: 'Please enter title',
    codeRequired: 'Please enter code',
    contentRequired: 'Please enter content',
    titleMaxLength: 'Title cannot exceed 255 characters',
    codeMaxLength: 'Code cannot exceed 32 characters',
    loadError: 'Failed to load policy information',
    createSuccess: 'Policy created successfully',
    createError: 'Failed to create policy',
    updateSuccess: 'Policy updated successfully',
    updateError: 'Failed to update policy',
    deleteSuccess: 'Policy deleted successfully',
    deleteError: 'Failed to delete policy',
  },

  // Report Category Management
  reportCategory: {
    title: 'Report Category',
    create: 'Create Report Category',
    edit: 'Edit Report Category',
    name: 'Category Name',
    targetType: 'Target Type',
    sortOrder: 'Sort Order',
    parentId: 'Parent ID',
    namePlaceholder: 'Enter category name',
    targetTypePlaceholder: 'Select target type',
    statusPlaceholder: 'Select status',
    parentIdPlaceholder: '0 for top level',
    nameRequired: 'Category name is required',
    targetTypeRequired: 'Target type is required',
    isActiveRequired: 'Please select active status',
    targetTypeAll: 'All',
    targetTypeUser: 'User',
    targetTypeNote: 'Note',
    targetTypeComment: 'Comment'
  },

  // Report Record Management
  reportRecord: {
    title: 'Report Records',
    targetId: 'Target ID',
    targetUserId: 'Target User ID',
    targetType: 'Type',
    categoryId: 'Category ID',
    categoryName: 'Category',
    categoryTargetType: 'Category target type',
    description: 'Description',
    reporterId: 'Reporter ID',
    targetIdPlaceholder: 'Target ID',
    reporterIdPlaceholder: 'Reporter ID',
    targetTypePlaceholder: 'Type',
    categoryIdPlaceholder: 'Category ID'
  },

  // Department Management
  department: {
    title: 'Department Management',
    list: 'Department List',
    create: 'Create Department',
    edit: 'Edit Department',
    addChild: 'Add Child Department',
    name: 'Department Name',
    code: 'Department Code',
    parent: 'Parent Department',
    leader: 'Leader',
    phone: 'Phone',
    email: 'Email',
    orderNum: 'Sort Order',
    description: 'Description',
    enabled: 'Enabled',
    disabled: 'Disabled',
    tree: 'Department Tree',
    detail: 'Department Detail',
    parentPlaceholder: 'Please select parent department',
    namePlaceholder: 'Please enter department name',
    codePlaceholder: 'Please enter department code',
    leaderPlaceholder: 'Please enter leader',
    phonePlaceholder: 'Please enter phone',
    emailPlaceholder: 'Please enter email',
    orderNumPlaceholder: 'Please enter sort order',
    descriptionPlaceholder: 'Please enter description',
    noParent: 'None',
    notSet: 'Not Set',
    nameRequired: 'Please enter department name',
    codeRequired: 'Please enter department code',
    createSuccess: 'Department created successfully',
    createError: 'Failed to create department',
    updateSuccess: 'Department updated successfully',
    updateError: 'Failed to update department',
    deleteSuccess: 'Department deleted successfully',
    deleteError: 'Failed to delete department',
    deleteConfirm: 'Are you sure you want to delete this department?',
    cannotDeleteWithChildren: 'Cannot delete department with children',
    loadError: 'Failed to load department tree',
    loadChildrenError: 'Failed to load child departments'
  },

  // Administrative Division Management
  division: {
    title: 'Administrative Division Management',
    list: 'Division List',
    create: 'Create Division',
    edit: 'Edit Division',
    name: 'Name',
    shortName: 'Short Name',
    mergerName: 'Merger Name',
    id: 'Division ID',
    code: 'Division Code',
    parentCode: 'Parent Code',
    level: 'Level',
    level1: 'Province/Municipality',
    level2: 'Prefecture-level City',
    level3: 'County/District',
    level4: 'Street/Township',
    level5: 'Community/Village',
    cityCode: 'City Code',
    zipCode: 'Zip Code',
    pinyin: 'Pinyin',
    lng: 'Longitude',
    lat: 'Latitude',
    sortOrder: 'Sort Order',
    namePlaceholder: 'Please enter name',
    shortNamePlaceholder: 'Please enter short name',
    mergerNamePlaceholder: 'Please enter merger name',
    idPlaceholder: 'Please enter division ID (12 digits)',
    codePlaceholder: 'Please enter division code',
    parentCodePlaceholder: 'Please enter parent code (optional for top level)',
    levelPlaceholder: 'Please select level',
    cityCodePlaceholder: 'Please enter city code',
    zipCodePlaceholder: 'Please enter zip code',
    pinyinPlaceholder: 'Please enter pinyin',
    lngPlaceholder: 'Please enter longitude',
    latPlaceholder: 'Please enter latitude',
    sortOrderPlaceholder: 'Please enter sort order',
    nameRequired: 'Please enter name',
    idRequired: 'Please enter division ID',
    idInvalid: 'Division ID can only contain digits',
    idMaxLength: 'Division ID can be at most 12 digits',
    codeRequired: 'Please enter division code',
    levelRequired: 'Please select level',
    levelRange: 'Level must be between 1 and 5',
    codeInvalid: 'Division code must be a number',
    createSuccess: 'Division created successfully',
    createError: 'Failed to create division',
    updateSuccess: 'Division updated successfully',
    updateError: 'Failed to update division',
    deleteSuccess: 'Division deleted successfully',
    deleteError: 'Failed to delete division',
    loadError: 'Failed to load divisions',
    searchError: 'Failed to search divisions'
  },

  // Country management (localized names)
  country: {
    title: 'Country Management',
    create: 'Create Country',
    edit: 'Edit Country',
    isoCode2: 'ISO alpha-2',
    isoCode3: 'ISO alpha-3',
    isoCode2Placeholder: 'Optional, e.g. US',
    isoCode3Placeholder: 'Required, e.g. USA',
    isoCode3Required: 'Please enter ISO alpha-3 code',
    isoCode3Len: 'ISO alpha-3 must be exactly 3 characters',
    nameZh: 'Chinese name',
    nameEn: 'English name',
    nameZhPlaceholder: 'Simplified Chinese display name',
    nameEnPlaceholder: 'English display name',
    nameZhRequired: 'Please enter Chinese name',
    nameEnRequired: 'Please enter English name',
    localizedName: 'Name (current UI language)',
    nameKeyword: 'Name keyword',
    nameKeywordPlaceholder: 'Fuzzy search in current UI language',
    listLanguageHint:
      'The name column follows the UI language: requests include languageId, matching sys_country_description.language_id.',
    statusPlaceholder: 'Status',
    statusRequired: 'Please select status',
    loadError: 'Failed to load countries',
    createSuccess: 'Country created successfully',
    createError: 'Failed to create country',
    updateSuccess: 'Country updated successfully',
    updateError: 'Failed to update country'
  },

  // Message template management
  messageTemplate: {
    title: 'Message Template Management',
    list: 'Message Template List',
    create: 'Create Message Template',
    edit: 'Edit Message Template',
    code: 'Template Code',
    codePlaceholder: 'Please enter template code, e.g. ORDER_CREATED_NOTIFY_APPRAISER',
    codeRequired: 'Please enter template code',
    codeLength: 'Template code cannot exceed 100 characters',
    titleTemplate: 'Title Template',
    titleTemplatePlaceholder: 'Please enter title template, optional',
    contentTemplate: 'Content Template',
    contentTemplatePlaceholder: 'Please enter message content template',
    contentTemplateRequired: 'Please enter content template',
    channelType: 'Channel Type',
    channelTypeRequired: 'Please select channel type',
    channelTypeText: 'TIM Text Message',
    channelTypeCustom: 'TIM Custom Message',
    enabledPlaceholder: 'Please select status',
    enabledRequired: 'Please select status',
    remark: 'Remark',
    remarkPlaceholder: 'Optional, describe template purpose or business context',
    remarkLength: 'Remark cannot exceed 255 characters',
    extJson: 'Extended JSON',
    extJsonPlaceholder: 'Please enter valid JSON, e.g. {"path":"/order/detail","orderNo":"${orderNo}"}',
    extJsonInvalid: 'Extended JSON is invalid, please enter valid JSON',
    loadError: 'Failed to load message templates',
    loadDetailError: 'Failed to load message template detail',
    createSuccess: 'Message template created successfully',
    createError: 'Failed to create message template',
    updateSuccess: 'Message template updated successfully',
    updateError: 'Failed to update message template'
  },

  // App mobile menu management
  appMenu: {
    title: 'App Menu Management',
    currentVersion: 'Published Version',
    publish: 'Publish Menus',
    publishSuccess: 'Menus published successfully',
    publishError: 'Failed to publish menus',
    preview: 'Preview',
    previewTitle: 'Menu Preview',
    previewCustomerId: 'Customer ID',
    previewIdentities: 'Simulated Identities',
    previewIdentitiesPlaceholder: 'Select identities to simulate',
    previewLocale: 'Locale',
    previewRun: 'Run Preview',
    previewEmpty: 'Run preview first',
    treeTitle: 'Menu Tree',
    detailTitle: 'Menu Detail',
    createMenu: 'Create Menu Item',
    editMenu: 'Edit Menu Item',
    addRoot: 'Add Root Menu',
    addChild: 'Add Child Menu',
    loadError: 'Failed to load menus',
    code: 'Menu Code',
    codePlaceholder: 'e.g. home / circle / service-orders',
    codeRequired: 'Please enter menu code',
    menuZone: 'Menu Zone',
    menuZoneRequired: 'Please select menu zone',
    defaultName: 'Default Name',
    defaultNamePlaceholder: 'Default display name (zh-CN fallback)',
    defaultNameRequired: 'Please enter default name',
    i18nTitle: 'Localized Names',
    i18nName: 'Display Name',
    i18nNamePlaceholder: 'Enter display name for {locale}',
    i18nHint: 'App resolves name by user locale; falls back to default name when missing.',
    showName: 'Show Menu Name',
    showIcon: 'Show Menu Icon',
    iconPath: 'Default Icon Path',
    iconPathPlaceholder: 'e.g. assets/menu-icons/tab_home.png',
    iconActivePath: 'Selected Icon Path',
    iconActivePathPlaceholder: 'e.g. assets/menu-icons/tab_home_active.png',
    iconPathHint: 'Client-side static asset paths. Use iconPath when idle, iconActivePath when selected.',
    routeSection: 'Navigation',
    routeType: 'Route Type',
    routeNative: 'Native Screen',
    routeWebview: 'WebView',
    routeAction: 'Client Action',
    routeExternal: 'External Link',
    routeDivider: 'Divider',
    routeTarget: 'Route Target',
    routeTargetPlaceholder: 'Select from route registry',
    routePath: 'Custom Path / URL',
    routePathPlaceholder: 'e.g. https://example.com or /custom/path',
    routePathPreview: 'Resolved Path',
    routePathHint: 'Auto-filled from route registry; App Router maps routeTarget to Screen.',
    actionCode: 'Action Code',
    groupCode: 'Sidebar Group',
    groupCodePlaceholder: 'Select group (sidebar only)',
    sortOrder: 'Sort Order',
    badgeType: 'Badge Type',
    badgeNone: 'None',
    badgeDot: 'Dot',
    badgeCount: 'Count',
    badgeApi: 'Badge Source',
    minAppVersion: 'Min App Version',
    minAppVersionPlaceholder: 'e.g. 1.2.0, leave empty for no limit',
    remark: 'Remark',
    ruleSection: 'Visibility Rules',
    addRule: 'Add Rule',
    ruleItem: 'Rule {index}',
    ruleMode: 'Rule Mode',
    ruleAlways: 'Always Show',
    ruleIfHas: 'Show When Has Identity',
    ruleIfNotHas: 'Show When Not Has Identity',
    ruleIfAny: 'Show When Has Any',
    ruleIfAll: 'Show When Has All',
    identityCodes: 'Identities',
    identityCodesPlaceholder: 'Select identity codes',
    vipRequired: 'VIP Required',
    routeRegistryTitle: 'Client Route Registry',
    routeRegistryHint: 'Select a menu item on the left; registry defines App Screen mapping contract.',
    routeRegistryCode: 'Route Code',
    routeRegistryPath: 'Path',
    routeRegistryScreen: 'Native Screen',
    routeRegistryLabel: 'Label',
    zone: {
      bottomNav: 'Bottom Nav',
      topNav: 'Top Nav',
      topNavSub: 'Sub Tabs',
      sidebar: 'Sidebar',
      sidebarUtility: 'Sidebar Utility',
      sidebarSub: 'Sidebar Sub'
    }
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    totalUsers: 'Total Users',
    activeUsers: 'Active Users',
    newUsersToday: 'New Users Today',
    onlineUsers: 'Online Users',
    userGrowth: 'User Growth',
    userActivity: 'User Activity',
    recentActivities: 'Recent Activities',
    userRegistration: 'User Registration',
    userLogin: 'User Login',
    profileUpdate: 'Profile Update',
    userLogout: 'User Logout',
    minutesAgo: 'minutes ago',
    newUserRegistered: 'New user "{username}" registered',
    userLoggedIn: 'User "{username}" logged in',
    userUpdatedProfile: 'User "{username}" updated profile',
    userLoggedOut: 'User "{username}" logged out'
  },

  // Store Application
  storeApplication: {
    title: 'Store Application Review',
    list: 'Store Application List',
    reviewButtonText: 'Review',
    review: 'Review Store Application',
    storeName: 'Store Name',
    storeNamePlaceholder: 'Please enter store name',
    realName: 'Name',
    realNamePlaceholder: 'Please enter name',
    phone: 'Phone',
    phonePlaceholder: 'Please enter phone',
    contactName: 'Contact Name',
    contactPhone: 'Contact Phone',
    province: 'Province',
    city: 'City',
    county: 'County',
    address: 'Address',
    status: 'Review Status',
    statusPlaceholder: 'Please select review status',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    rejectReason: 'Reject Reason',
    rejectReasonPlaceholder: 'Please enter reject reason (required when rejecting)',
    remark: 'Review Remark',
    remarkPlaceholder: 'Please enter review remark',
    approve: 'Approve',
    reject: 'Reject',
    submittedAt: 'Submitted Time',
    reviewedAt: 'Review Time',
    loadError: 'Failed to load application list',
    loadDetailError: 'Failed to load application detail',
    reviewSuccess: 'Review successful',
    reviewError: 'Review failed',
    approveConfirm: 'Are you sure to approve this application?',
    rejectConfirm: 'Are you sure to reject this application?',
    rejectReasonRequired: 'Reject reason is required when rejecting',
    certifications: 'Certifications',
    certificationType1: 'Business License',
    certificationType2: 'Tobacco License',
    certificationType3: 'Cigar Sales License',
    certificationType4: 'Store Photo',
    certificationType5: 'Legal Person ID Front',
    certificationType6: 'Legal Person ID Back',
    longitude: 'Longitude',
    latitude: 'Latitude',
    customerId: 'Customer ID'
  },

  // Store Category Management
  store: {
    // Store Management
    storeManagement: {
      title: 'Store Management',
      list: 'Store List',
      edit: 'Edit Store',
      name: 'Store Name',
      namePlaceholder: 'Please enter store name',
      nameRequired: 'Please enter store name',
      status: 'Status',
      statusPlaceholder: 'Please select status',
      statusNormal: 'Normal',
      statusDisabled: 'Disabled',
      province: 'Province',
      provincePlaceholder: 'Please enter province',
      city: 'City',
      cityPlaceholder: 'Please enter city',
      county: 'County',
      countyPlaceholder: 'Please enter county',
      address: 'Address',
      addressPlaceholder: 'Please enter address',
      addressRequired: 'Please enter address',
      longitude: 'Longitude',
      longitudePlaceholder: 'Please enter longitude',
      latitude: 'Latitude',
      latitudePlaceholder: 'Please enter latitude',
      userId: 'User ID',
      userIdPlaceholder: 'Please enter user ID',
      userIdRequired: 'Please enter user ID',
      createdAt: 'Created At',
      updatedAt: 'Updated At',
      loadError: 'Failed to load store list',
      loadDetailError: 'Failed to load store details',
      updateSuccess: 'Store updated successfully',
      updateError: 'Failed to update store'
    },
    category: {
      title: 'Product Category Management',
      list: 'Category List',
      create: 'Create Category',
      edit: 'Edit Category',
      name: 'Category Name',
      description: 'Category Description',
      parentCategory: 'Parent Category',
      image: 'Category Image',
      sortOrder: 'Sort Order',
      topLevel: 'Top Level',
      unknown: 'Unknown Category',
      namePlaceholder: 'Please enter category name',
      descriptionPlaceholder: 'Please enter category description',
      parentCategoryPlaceholder: 'Please select parent category',
      sortOrderPlaceholder: 'Please enter sort order',
      nameRequired: 'Please enter category name',
      descriptionRequired: 'Please enter category description',
      sortOrderRequired: 'Please enter sort order',
      createSuccess: 'Category created successfully',
      createError: 'Failed to create category',
      updateSuccess: 'Category updated successfully',
      updateError: 'Failed to update category',
      deleteSuccess: 'Category deleted successfully',
      deleteError: 'Failed to delete category',
      deleteConfirm: 'Are you sure you want to delete category "{name}"?',
      hasChildrenWarning: 'This category has child categories and cannot be deleted! Please delete child categories first.',
      checkChildrenError: 'Failed to check child categories',
      loadError: 'Failed to load categories'
    },
    attribute: {
      title: 'Product Attribute Management',
      list: 'Attribute List',
      create: 'Create Attribute',
      edit: 'Edit Attribute',
      attributeId: 'Attribute ID',
      name: 'Attribute Name',
      sortOrder: 'Sort Order',
      namePlaceholder: 'Please enter attribute name',
      searchPlaceholder: 'Search attribute name',
      createSuccess: 'Attribute created successfully',
      createError: 'Failed to create attribute',
      updateSuccess: 'Attribute updated successfully',
      updateError: 'Failed to update attribute',
      deleteSuccess: 'Attribute deleted successfully',
      deleteError: 'Failed to delete attribute',
      deleteConfirm: 'Are you sure you want to delete this attribute?',
      loadError: 'Failed to load attribute list'
    },
    deliveryTemplate: {
      title: 'Delivery Template',
      list: 'Delivery template list',
      create: 'New delivery template',
      createBreadcrumb: 'New template',
      editBreadcrumb: 'Edit template',
      edit: 'Edit delivery template',
      templateName: 'Template name',
      templateNamePlaceholder: 'Please enter name',
      shippingOrigin: 'Shipping origin',
      shippingOriginPlaceholder: 'Please select shipping origin',
      provincePlaceholder: 'Please select province',
      cityPlaceholder: 'Please select city',
      districtPlaceholder: 'Please select district',
      freightType: 'Freight type',
      freightTypeStep: 'Tiered pricing',
      freightTypeFixed: 'Fixed shipping',
      freightTypeFree: 'Free shipping',
      freightTypeFreeWarning: 'This shop has enabled remote-region logistics (Xinjiang only). Except restricted areas, this template is free of shipping nationwide via direct/transit fulfillment.',
      pricingMethod: 'Pricing method',
      byQuantity: 'By piece',
      byWeight: 'By weight',
      byVolume: 'By volume',
      unitPiece: 'pcs',
      unitWeight: 'kg',
      unitVolume: 'm³',
      shippingCalc: 'Shipping calc',
      shippingCalcDesc: 'For regions other than the specified ones, the "default freight" is used',
      directRuleTitle: 'Direct mail freight rule',
      directRuleHint: 'Default rule, used when no area-specific or conditional free rule matches',
      defaultFreight: 'Default freight',
      defaultFixedFreight: 'Default fixed shipping',
      placeholder: 'Enter',
      within: ' within',
      yuan: 'CNY',
      yuanComma: 'CNY,',
      yuanPerOrder: 'CNY/order',
      perAdd: 'per additional',
      addFreight: 'add freight',
      comma: ', ',
      areaRuleTitle: 'Area-specific freight',
      addArea: 'Add area',
      freeRuleTitle: 'Conditional free shipping',
      freeRuleHint: 'Set "free shipping above X CNY" for the specified region. When the condition is met, free shipping wins; otherwise tiered pricing is used.',
      freeRuleHintFixed: 'Set "free shipping above X CNY" for the specified region. When the condition is met, free shipping wins; otherwise fixed pricing is used.',
      modalTitleArea: 'Add area-specific freight',
      modalTitleFree: 'Add conditional free shipping',
      applicableAreas: 'Applicable areas',
      selectAreas: 'Please select areas',
      selectAreasRequired: 'Please select at least one area',
      startStandardLabel: 'First {unit}',
      startFeeLabel: 'First fee',
      addStandardLabel: 'Each additional {unit}',
      addFeeLabel: 'Additional fee',
      fixedFeeLabel: 'Fixed shipping amount',
      freeConditionType: 'Free condition',
      freeCondQty: 'Min quantity ({unit})',
      freeCondAmount: 'Min amount',
      freeCondBoth: 'Both',
      freeStandardLabel: 'Min {unit} threshold',
      freeAmountLabel: 'Min amount threshold',
      stepFeeSummary: 'First {startStandard}{unit} {startFee}, +{addFee} per {addStandard}{unit}',
      fixedFeeSummary: 'Fixed {fee}/order',
      freeSummaryQty: 'Free over {v} {unit}',
      freeSummaryAmount: 'Free over {v} CNY',
      freeSummaryBoth: 'Free over {qty} {unit} and {amount} CNY',
      fillStepFee: 'Please complete all tiered pricing fields',
      fillFixedFee: 'Please enter fixed shipping amount',
      fillFreeStandard: 'Please enter qty/weight/volume threshold',
      fillFreeAmount: 'Please enter amount threshold',
      templateNameRequired: 'Please enter template name',
      shippingOriginRequired: 'Please select shipping origin',
      freightTypeRequired: 'Please select freight type',
      pricingMethodRequired: 'Please select pricing method',
      createSuccess: 'Delivery template created successfully',
      createError: 'Failed to create delivery template',
      updateSuccess: 'Delivery template updated successfully',
      updateError: 'Failed to update delivery template',
      deleteSuccess: 'Delivery template deleted successfully',
      deleteError: 'Failed to delete delivery template'
    }
  },

  // Authentication (extended)
  auth: {
    login: 'Login',
    loginTitle: 'User Login',
    registerTitle: 'User Registration',
    username: 'Username',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    email: 'Email',
    phone: 'Phone',
    captcha: 'Captcha',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password',
    loginSuccess: 'Login Successful',
    loginFailed: 'Login Failed',
    registerSuccess: 'Registration Successful',
    registerFailed: 'Registration Failed',
    logoutSuccess: 'Logout Successful',
    invalidCredentials: 'Invalid username or password',
    invalidCaptcha: 'Invalid captcha',
    usernamePlaceholder: 'Please enter username',
    passwordPlaceholder: 'Please enter password',
    emailPlaceholder: 'Please enter email',
    phonePlaceholder: 'Please enter phone number',
    captchaPlaceholder: 'Please enter captcha',
    confirmPasswordPlaceholder: 'Please confirm password',
    usernameRequired: 'Please enter username',
    passwordRequired: 'Please enter password',
    emailRequired: 'Please enter email',
    phoneRequired: 'Please enter phone number',
    captchaRequired: 'Please enter captcha',
    confirmPasswordRequired: 'Please confirm password',
    passwordMismatch: 'Passwords do not match',
    passwordMinLength: 'Password must be at least 6 characters',
    usernameLength: 'Username must be 3-20 characters',
    emailInvalid: 'Please enter a valid email address',
    phoneInvalid: 'Please enter a valid phone number',
    noAccount: 'No account yet?',
    hasAccount: 'Already have an account?',
    registerLink: 'Register',
    loginLink: 'Login here',
    registerSubtitle: 'Please fill in the information to register',
    captchaLoadError: 'Failed to load captcha',
    checkInput: 'Please check your input',
    createAccount: 'Create Account'
  },

  // Coupon Management
  coupon: {
    title: 'Coupon Management',
    list: 'Coupon List',
    create: 'Create Coupon',
    edit: 'Edit Coupon',
    name: 'Name',
    code: 'Code',
    type: 'Type',
    discount: 'Discount Amount',
    total: 'Threshold Amount',
    dateStart: 'Start Date',
    dateEnd: 'End Date',
    usageTime: 'Usage Time',
    usesTotal: 'Total Quantity (sheets)',
    usesCustomer: 'Limit Per Person (sheets)',
    status: 'Status',
    statusPlaceholder: 'Please select status',
    start: 'Start',
    end: 'End',
    to: 'to',
    productScope: 'Product Scope',
    basicInfo: 'Basic Information',
    discountInfo: 'Discount Information',
    thresholdAmount: 'Threshold Amount',
    full: 'Full',
    reduce: 'Reduce',
    selectProducts: 'Select Products',
    productName: 'Product Name',
    productPrice: 'Product Price',
    namePlaceholder: 'Please enter name',
    codePlaceholder: 'Please enter coupon code',
    dateStartPlaceholder: 'Start',
    dateEndPlaceholder: 'End',
    totalPlaceholder: 'Please enter threshold amount',
    discountPlaceholder: 'Please enter discount amount',
    usesTotalPlaceholder: 'Please enter an integer between 1000-100000',
    usesCustomerPlaceholder: 'Please select limit per person',
    unlimited: 'Unlimited',
    sheets: 'sheets',
    nameRequired: 'Please enter coupon name',
    dateStartRequired: 'Please select start date',
    dateEndRequired: 'Please select end date',
    dateRangeRequired: 'Please select usage time',
    nameMaxLength: 'Name cannot exceed 10 characters',
    dateEndBeforeStart: 'End date cannot be earlier than start date',
    totalMin: 'Threshold amount cannot be less than 0',
    discountMin: 'Discount amount cannot be less than 0',
    discountLessThanTotal: 'Discount amount must be less than threshold amount',
    usesTotalMin: 'Total quantity cannot be less than 0',
    usesTotalRange: 'Total quantity must be between 1000-100000',
    usesCustomerMin: 'Limit per person cannot be less than 0',
    usesCustomerLessThanTotal: 'Limit per person cannot exceed total quantity',
    createSuccess: 'Coupon created successfully',
    createError: 'Failed to create coupon',
    updateSuccess: 'Coupon updated successfully',
    updateError: 'Failed to update coupon',
    deleteSuccess: 'Coupon deleted successfully',
    deleteError: 'Failed to delete coupon',
    loadProductsError: 'Failed to load product list'
  },

  // Checkin Reward Rule
  checkinRewardRule: {
    title: 'Checkin Reward Rules',
    create: 'Create Checkin Reward Rule',
    edit: 'Edit Checkin Reward Rule',
    ruleId: 'Rule ID',
    sourceType: 'Source Type',
    sourceTypePlaceholder: 'Please select source type',
    sourceTypeRequired: 'Source type is required',
    rewardType: 'Reward Type',
    rewardTypePlaceholder: 'Please select reward type',
    rewardTypeRequired: 'Reward type is required',
    rewardTypePoint: 'Points',
    rewardTypeCoupon: 'Coupon',
    rewardTypeVirtualCoin: 'Virtual Coin',
    rewardValue: 'Reward Value',
    rewardValuePlaceholder: 'Please enter reward value',
    rewardValueRequired: 'Reward value is required',
    rewardValueMin: 'Reward value must be greater than 0',
    continuousDay: 'Continuous Days',
    continuousDayPlaceholder: 'Please enter continuous days',
    continuousDayRequired: 'Continuous days is required',
    continuousDayMin: 'Continuous days must be greater than 0',
    rewardHint: 'Reward Hint',
    rewardHintPlaceholder: 'Please enter reward hint',
    rewardHintRequired: 'Reward hint is required',
    enabled: 'Status',
    enabledPlaceholder: 'Please select status',
    enabledRequired: 'Status is required',
    loadError: 'Failed to load checkin reward rules',
    createSuccess: 'Checkin reward rule created successfully',
    createError: 'Failed to create checkin reward rule',
    updateSuccess: 'Checkin reward rule updated successfully',
    updateError: 'Failed to update checkin reward rule'
  },

  // Emoji Tab
  emoji: {
    title: 'Emoji Tab Management',
    list: 'Emoji Tab List',
    create: 'Create Emoji Tab',
    edit: 'Edit Emoji Tab',
    tabName: 'Tab Name',
    tabNamePlaceholder: 'Please enter tab name',
    tabNameRequired: 'Tab name is required',
    imagePath: 'Image',
    darkImagePath: 'Dark Mode Image',
    sortOrder: 'Sort Order',
    basicInfo: 'Basic Information',
    emojis: 'Emojis',
    addEmoji: 'Add Emoji',
    text: 'Text',
    tupleTitle: 'Title',
    loadError: 'Failed to load emoji tab',
    createSuccess: 'Emoji tab created successfully',
    createError: 'Failed to create emoji tab',
    updateSuccess: 'Emoji tab updated successfully',
    updateError: 'Failed to update emoji tab',
    deleteSuccess: 'Emoji tab deleted successfully',
    deleteError: 'Failed to delete emoji tab',
    // Emoji Tuple related
    tupleCreate: 'Create Emoji Tuple',
    tupleEdit: 'Edit Emoji Tuple',
    tabId: 'Tab ID',
    tabIdPlaceholder: 'Please enter tab ID',
    tabIdRequired: 'Tab ID is required',
    tupleType: 'Type',
    tupleTypePlaceholder: 'Please select type',
    tupleTypeRequired: 'Type is required',
    tupleTypeImage: 'Image',
    tupleTypeAnimation: 'Animation',
    textPlaceholder: 'Please enter text, e.g. [symbols188], [比心]',
    textRequired: 'Text is required',
    titlePlaceholder: 'Please enter title',
    imageName: 'Image Name',
    imageNamePlaceholder: 'Please enter image name',
    lottieName: 'Lottie Name',
    lottieNamePlaceholder: 'Please enter lottie name',
    color: 'Color',
    colorPlaceholder: 'Please enter color value, e.g. #FBFCFC',
    tupleLoadError: 'Failed to load emoji tuple',
    tupleCreateSuccess: 'Emoji tuple created successfully',
    tupleCreateError: 'Failed to create emoji tuple',
    tupleUpdateSuccess: 'Emoji tuple updated successfully',
    tupleUpdateError: 'Failed to update emoji tuple',
    tupleDeleteSuccess: 'Emoji tuple deleted successfully',
    tupleDeleteError: 'Failed to delete emoji tuple'
  },
  // Order Management
  order: {
    title: 'Order Management',
    list: 'Order List',
    orderNo: 'Order No',
    orderNoPlaceholder: 'Please enter order number',
    fullname: 'Customer Name',
    fullnamePlaceholder: 'Please enter customer name',
    status: 'Order Status',
    statusPlaceholder: 'Please select order status',
    total: 'Total Amount',
    telephone: 'Telephone',
    updateStatus: 'Update Status',
    detail: 'Order Detail',
    consign: 'Ship',
    confirmOrderInfo: 'Confirm Order Info',
    paidDuration: 'Paid Duration',
    paymentTime: 'Payment Time',
    latestShippingTime: 'Latest Shipping Time',
    shipAll: 'Ship All',
    buyerShippingInfo: 'Buyer Shipping Info',
    buyerMessage: 'Buyer Message',
    confirmConsignInfo: 'Confirm Consign/Return Info',
    myConsignInfo: 'My Consign Info',
    myReturnInfo: 'My Return Info',
    selectConsignMethod: 'Select Consign Method',
    methodSelf: 'Self Contact Logistics',
    methodCainiao: 'Cainiao Guoguo',
    methodNone: 'No Logistics',
    methodLocal: 'Local Delivery',
    methodStore: 'Store Delivery',
    methodInternational: 'International Shipping',
    methodLarge: 'Large Item Express',
    addLogisticNo: 'Add Logistic No',
    selectLogisticCompany: 'Select Logistic Company',
    multiConsign: 'Multi-waybill Consign',
    confirmConsign: 'Confirm and Consign',
    consignRemarkPlaceholder: 'Consign remark, only visible to yourself',
    pleaseInputLogisticNo: 'Please input logistic no',
    consignSuccess: 'Consign success',
    consignFailed: 'Consign failed',
    printWaybill: 'Print Waybill',
    printWaybillTitle: 'Print Waybill',
    printWaybillTab: 'Print Waybill',
    startPrint: 'Start Print',
    printing: 'Preparing print...',
    printSuccess: 'Print success',
    printFailed: 'Print failed'
  },

  sommelierOrder: {
    title: 'Sommelier Order List',
    orderNo: 'Order No.',
    orderNoPlaceholder: 'Please enter order number',
    customer: 'Customer',
    sommelier: 'Sommelier',
    phone: 'Phone',
    payPrice: 'Payment Amount',
    payStatus: 'Payment Status',
    payStatusPaid: 'Paid',
    payStatusUnpaid: 'Unpaid',
    status: 'Business Status',
    statusNewOrder: 'New Order',
    statusPendingService: 'Pending Service',
    statusInService: 'In Service',
    statusCompleted: 'Completed',
    state: 'System State',
    statePendingPayment: 'Pending Payment',
    statePaid: 'Paid',
    stateAccepted: 'Accepted',
    stateInService: 'In Service',
    stateServiceCompleted: 'Service Completed',
    stateUserCanceled: 'User Canceled',
    stateSommelierCanceled: 'Sommelier Canceled',
    stateSystemCanceled: 'System Canceled',
    stateServiceClosed: 'Service Closed',
    refundStatus: 'Refund Status',
    refundStatusNone: 'No Refund',
    refundStatusRefunding: 'Refunding',
    refundStatusSuccess: 'Refund Success',
    refundStatusFailed: 'Refund Failed',
    orderTime: 'Order Time',
    startTime: 'Start Time',
    endTime: 'End Time',
    loadError: 'Failed to load order list'
  },

  appraiserOrder: {
    title: 'Appraiser Order List',
    orderNo: 'Order No',
    orderNoPlaceholder: 'Please enter order number',
    customer: 'Customer',
    appraiser: 'Appraiser',
    cigar: 'Brand / Series',
    payAmount: 'Pay Amount',
    state: 'System State',
    state0: 'Pending Payment',
    state1: 'Paid',
    state2: 'Pending Appraisal',
    state3: 'Appraising',
    state4: 'Appraisal Done',
    state5: 'Pending Review',
    state6: 'User Cancelled',
    state7: 'System Cancelled',
    state8: 'Service Closed',
    status: 'Order Status',
    status1: 'Pending Appraisal',
    status2: 'Appraising',
    status3: 'Appraised',
    status4: 'Completed',
    flags: 'Flags',
    urgent: 'Urgent',
    onsite: 'On-site',
    createdAt: 'Create Time',
    loadError: 'Failed to load appraiser order list'
  },

  sensitiveWord: {
    title: 'Word Library',
    word: 'Word',
    wordPlaceholder: 'Please enter a sensitive word',
    level: 'Level',
    levelForbidden: 'Forbidden',
    levelReview: 'Review',
    levelRateLimit: 'Rate Limited',
    levelPlaceholder: 'Please select level',
    levelFilterPlaceholder: 'All',
    enabled: 'Enabled',
    createdAt: 'Created At',
    keywordPlaceholder: 'Search by sensitive word',
    create: 'Add Sensitive Word',
    edit: 'Edit Sensitive Word',
    reload: 'Reload Dictionary',
    reloadSuccess: 'Sensitive word dictionary reloaded',
    reloadError: 'Failed to reload dictionary',
    deleteConfirm: 'Are you sure to delete this sensitive word?',
    levelRequired: 'Please select level',
    wordRequired: 'Sensitive word is required',
    loadError: 'Failed to load sensitive word list',
    downloadTemplate: 'Download Template',
    exportLexicon: 'Export',
    importLexicon: 'Import',
    importSuccess: 'Import succeeded: {created} created, {updated} updated',
    importFailed: 'Import failed',
    exportFailed: 'Export failed',
    downloadTemplateFailed: 'Failed to download template',
    importValidationFailed: 'Import validation failed. Please check the Excel file and try again',
    onlyXlsx: 'Only .xlsx files are supported',
    exporting: 'Exporting…',
    downloadingTemplate: 'Downloading template…',
    importing: 'Importing…',
  },

  payConfig: {
    title: 'Payment Settings',
    subtitle: 'Configure secure credentials and callback URLs for major payment gateways such as WeChat and Alipay',
    loadError: 'Failed to load payment configuration',
    statusEnabled: 'Enabled',
    statusDisabled: 'Disabled',
    isDefault: 'Default',
    channelVersion: 'Version',
    secretConfigured: 'Configured',
    fingerprint: 'Fingerprint',
    secretInputPh: 'Enter the plaintext secret (encrypted by the backend on submit)',
    secretReplacePh: 'Configured. Leave blank to keep unchanged; enter a new plaintext secret to replace',
    channel: {
      alipay: 'Alipay',
      wechat: 'WeChat Pay',
    },
    section: {
      environment: 'Environment',
      basic: 'Basic',
      secret: 'Secrets',
      notify: 'Notifications',
    },
    env: {
      production: 'Production',
      sandbox: 'Sandbox',
    },
    field: {
      environment: 'Environment',
      channelName: 'Display Name',
      channelNamePh: 'e.g. Alipay',
      appId: 'App ID',
      appIdPh: 'Enter App ID',
      appIdHint: 'App ID assigned by the Alipay Open Platform',
      merchantNo: 'Merchant No.',
      merchantNoPh: 'Enter merchant no. / seller ID',
      merchantNoHint: 'Merchant identifier from Alipay or WeChat',
      apiMethod: 'API Method',
      apiMethodPh: 'e.g. alipay.trade.app.pay',
      signType: 'Sign Type',
      signTypeHint: 'RSA2 is recommended for better security',
      certMode: 'Cert Mode',
      certModePh: 'Select cert mode',
      timeoutSeconds: 'Timeout (s)',
      timeoutSecondsPh: 'Request timeout',
      icon: 'Payment Icon',
      iconHint: 'Recommended 64×64px, PNG / SVG supported',
      iconUpload: 'Click or drag to upload icon',
      merchantPrivateKey: 'App Private Key',
      merchantPrivateKeyHint: 'RSA2 private key generated by the merchant; keep it secure',
      aliPublicKey: 'Alipay Public Key',
      aliPublicKeyPh: 'Enter the Alipay public key',
      aliPublicKeyHint: 'Used to verify Alipay async notification signatures',
      aliAppCertContent: 'App Public Cert',
      aliPublicCertContent: 'Alipay Public Cert',
      aliRootCertContent: 'Alipay Root Cert',
      aliGatewayUrl: 'Gateway URL',
      aliProductCode: 'Product Code',
      wxApiV3Key: 'WeChat APIv3 Key',
      wxApiV3KeyHint: 'APIv3 key configured in the WeChat merchant platform',
      wxMerchantPrivateKeyHint: 'Merchant API certificate private key; keep it secure',
      wxMchSerialNo: 'Merchant Cert Serial No.',
      wxApiDomain: 'API Domain',
      wxPlatformCertContent: 'WeChat Platform Cert',
      notifyUrl: 'Async Notification URL',
      notifyUrlHint: 'Server URL for payment result notifications; must be publicly accessible',
      refundNotifyUrl: 'Refund Callback URL',
      remark: 'Remark',
    },
    action: {
      save: 'Save Changes',
      enable: 'Enable',
      disable: 'Disable',
      setDefault: 'Set as Default',
    },
    validate: {
      channelName: 'Please enter the display name',
      appId: 'Please enter the App ID',
      merchantNo: 'Please enter the merchant no.',
      apiMethod: 'Please enter the API method',
    },
  },

  noteReview: {
    pageTitle: 'Post Management',
    detailTitle: 'Post Management Detail',
    // Tab keys aligned with backend GET .../sns/note/reviews/list?status= (0=All, 1=Published, 2=Pending, 3=Rejected)
    tabAll: 'All Posts',
    tabPublished: 'Published',
    tabPending: 'Pending Review',
    tabRejected: 'Rejected',
    totalPosts: '{total} posts in total',
    filterTitle: 'Title:',
    filterTitlePlaceholder: 'Search title',
    filterType: 'Type:',
    filterCategory: 'Category:',
    filterPriority: 'Priority:',
    filterAllPlaceholder: 'All',
    typeNormal: 'Image/Text',
    typeVideo: 'Video',
    category0: 'Recommend',
    category1: 'Cigar Review',
    category2: 'Cigar Meet',
    category3: 'Help',
    category4: 'Offline Bar',
    metricView: 'Views',
    metricLike: 'Likes',
    metricComment: 'Comments',
    metricShare: 'Shares',
    auditPost: 'Audit',
    deletePost: 'Delete',
    deleteConfirm: 'Delete this post?',
    deleteSuccess: 'Deleted',
    deleteError: 'Failed to delete',
    noReviewYet: 'No review record yet',
    // Priority codes align with backend NoteReview.Priority (higher = more urgent)
    priority: 'Priority',
    priorityNormal: 'Normal',
    priorityUrgent: 'Urgent',
    autoResult: 'Auto Result',
    autoResultMiss: 'No Hit',
    autoResultHit: 'Hit Keywords',
    hitWords: 'Hit Words',
    hitWordsEmpty: 'None',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    noteTitle: 'Note Title',
    customerNickname: 'Author',
    customerJump: 'Trace Author',
    auditTime: 'Audit Time',
    createdAt: 'Created At',
    auditAction: 'Audit',
    auditApprove: 'Approve',
    auditReject: 'Reject',
    rejectModalTitle: 'Reject',
    rejectReason: 'Reason',
    rejectReasonRequired: 'Please select a reject reason',
    rejectRemark: 'Audit Remark',
    rejectRemarkPlaceholder: 'Enter remark or choose a template',
    remarkTemplateLabel: 'Template',
    remarkTemplatePlaceholder: 'Append template to remark',
    auditApproveConfirm: 'Approve this post?',
    auditSuccess: 'Audit success',
    auditError: 'Audit failed',
    detailTabContent: 'Post Content',
    detailTabUser: 'Author',
    description: 'Description',
    images: 'Images',
    video: 'Video',
    videoUnavailable: 'No video',
    backToList: 'Back',
    loadError: 'Failed to load review list',
    detailLoadError: 'Failed to load review detail',
    statisticsLoadError: 'Failed to load review statistics',
    rejectReasonsLoadError: 'Failed to load reject reasons',
    remarkTemplatesLoadError: 'Failed to load remark templates',
    auditDetailHeading: 'Post review detail',
    idLabel: 'ID: {id}',
    sectionAutoReport: 'Auto screening report',
    detectStatus: 'Screening status',
    detectHitLibrary: 'Matched sensitive word list',
    detectMissLibrary: 'No sensitive word match',
    hitKeywords: 'Matched keywords',
    manualAudit: 'Manual review',
    auditConclusion: 'Decision',
    violationTypePick: 'Violation type',
    violationTypePickHint: '(pick one)',
    remarkHint: 'Describe the violation; this will be shown to the author…',
    commonPhrasesShort: 'Snippets',
    submitAudit: 'Submit decision',
    auditGuidelineTitle: 'Review guidelines',
    auditGuidelineItem1: 'No political or explicit content',
    auditGuidelineItem2: 'No off-site traffic or fraudulent deals',
    auditGuidelineItem3: 'Protect privacy; do not leak contact info',
    auditGuidelineItem4: 'Keep the community healthy; handle harassment',
    chooseAuditFirst: 'Please choose Approve or Reject first',
    auditResultSection: 'Review outcome',
    postPublishedAt: 'Posted at',
    filterKeyword: 'Keyword:',
    filterKeywordPlaceholder: 'Search title or author',
    filterAuditStatus: 'Audit status:',
    previewTitle: 'Detail preview',
    previewEmpty: 'Click a post on the left to preview',
    previewSensitiveTip: 'Sensitive words detected. Please review ASAP.',
    previewMoreImages: '+{count} more',
    previewOpenFull: 'Open full review detail',
    previewMetricsTitle: 'Engagement',
    statusUnderReview: 'Pending',
    statusPublishedShort: 'Published',
    statusUrgentTag: 'Urgent',
    phonePostDetail: 'Post detail',
    phoneProfilePreview: 'Profile',
    phoneFollowed: 'Following',
    phoneFollow: 'Follow',
    phoneCommentPlaceholder: 'Say something...',
    phoneYashId: 'Yash ID: {id}',
    phoneLocation: 'IP: {location}',
    phoneUnknownDescription: 'Recording real rural life and sharing every natural gift.',
    phoneFollowing: 'Following',
    phoneFollowers: 'Followers',
    phoneLikesCollections: 'Likes & saves',
    phoneNotes: 'Notes',
    phoneCollected: 'Saved',
    phoneLiked: 'Liked',
    phoneMerchantTag: 'Merchant',
    operationPanel: 'Action panel',
    pendingCount: 'Pending',
    auditedCount: 'Audited',
    autoDetectResult: 'Auto detection result',
    cancelBack: 'Cancel'
  },
  // Comment review (list comment/index.vue + detail comment/review.vue)
  commentReview: {
    pageTitle: 'Comment Review',
    tabAll: 'All',
    tabPending: 'Pending',
    tabApproved: 'Approved',
    tabRejected: 'Rejected',
    filterPriority: 'Tier:',
    filterNoteId: 'Post ID:',
    filterNoteIdPlaceholder: 'Post ID',
    filterCustomerId: 'Commenter ID:',
    filterCustomerIdPlaceholder: 'customer_id',
    filterAllPlaceholder: 'All',
    priority: 'Priority',
    priorityNormal: 'Normal',
    priorityUrgent: 'Urgent',
    machineDecision: 'Machine result',
    machinePass: 'Passed',
    machineSuspect: 'Suspect',
    machineBlock: 'Blocked',
    riskLevel: 'Risk level',
    hitKeywords: 'Hit keywords',
    hitWordsEmpty: 'None',
    hitLabel: 'Hits: ',
    statusPending: 'Pending',
    statusApproved: 'Approved',
    statusRejected: 'Rejected',
    statusUrgentTag: 'Urgent',
    auditComment: 'Review',
    previewTitle: 'Post preview',
    loadError: 'Failed to load comment reviews',
    auditDetailHeading: 'Comment Review Detail',
    idLabel: 'ID: {id}',
    operationPanel: 'Operation panel',
    pendingCount: 'Pending',
    auditedCount: 'Audited',
    commentContent: 'Comment',
    autoDetectResult: 'Auto detection result',
    manualAudit: 'Manual review',
    auditConclusion: 'Conclusion',
    auditApprove: 'Approve',
    auditReject: 'Reject',
    rejectRemark: 'Remark',
    rejectRemarkRequired: 'Please provide a rejection reason (visible to user)',
    remarkHint: 'Enter the rejection reason, shared with the commenter…',
    commonPhrasesShort: 'Phrases',
    submitAudit: 'Submit',
    chooseAuditFirst: 'Please choose Approve or Reject first',
    auditResultSection: 'Review result',
    auditSuccess: 'Reviewed successfully',
    auditError: 'Review failed',
    detailLoadError: 'Failed to load comment review detail',
    cancelBack: 'Cancel',
    phonePostDetail: 'Post detail',
    phoneProfilePreview: 'Profile'
  },
  // Product publish (Figma 4-Tab) — only used by store/product/create.vue
  productCreate: {
    pageTitle: 'Publish Product',
    refresh: 'Refresh',
    cancel: 'Cancel',
    submit: 'Submit',
    submitSuccess: 'Product created successfully',
    submitFailed: 'Failed to create product',
    backToList: 'Back to list',
    tabBasic: 'Basic',
    tabMedia: 'Media',
    tabPriceStock: 'Price & Stock',
    tabService: 'Service & Fulfillment',
    sectionBasic: 'Basic information',
    sectionMedia: 'Media',
    sectionPriceStock: 'Price & Stock',
    sectionService: 'Service & Fulfillment',
    title: 'Title',
    titlePlaceholder: 'Please enter product title',
    titleRequired: 'Please enter product title',
    titleMaxLength: 'Title must not exceed 60 characters',
    category: 'Product catalog',
    categoryPlaceholder: 'Please select product catalog',
    categoryRequired: 'Please select product catalog',
    attributes: 'Attributes',
    addAttribute: 'Add attribute',
    attributePlaceholder: 'Please select attribute',
    attributeValuePlaceholder: 'Please input value',
    removeAttribute: 'Remove',
    mainImages: 'Main images',
    mainImagesHint: 'Up to 5 images, 1:1 ratio recommended, ≤ 5MB each',
    mainImagesRequired: 'Please upload at least one main image',
    mainVideo: 'Main video',
    mainVideoHint: 'Optional, ≤ 100MB',
    detailImages: 'Detail images',
    detailImagesHint: 'Up to 50 images, ≤ 5MB each',
    fillFromMain: 'Fill from main images',
    deliveryTimeType: 'Delivery time',
    deliveryTimeTypeRequired: 'Please select delivery time',
    deliveryTimeNextDay: 'Next day',
    deliveryTime48h: '48 hours',
    deliveryTimeSameDay: 'Same day',
    subtractType: 'Stock subtract',
    subtractTypeRequired: 'Please select stock subtract type',
    subtractOnOrder: 'On order',
    subtractOnPay: 'On payment',
    specs: 'Specifications',
    addSpecType: 'Add spec type',
    specTypePlaceholder: 'Please select spec type',
    specTypeInputPlaceholder: 'Please input spec type',
    specTypeNameRequired: 'Please input spec type',
    specTypeCreateSuccess: 'Spec type created successfully',
    specTypeCreateFailed: 'Failed to create spec type',
    addSpecImage: 'Add spec image',
    moveDown: 'Down',
    moveUp: 'Up',
    specValuePlaceholder: 'Please input {name}',
    specValueDuplicate: 'Spec value already exists',
    specValueCreateFailed: 'Failed to add spec value',
    customSortOrder: 'Custom sort',
    specCount: 'Spec types ({current}/{max})',
    skuTable: 'Price & Stock',
    skuPrice: 'Price',
    skuPricePlaceholder: 'Please input',
    skuPriceRequired: 'Please input price',
    skuStock: 'Stock',
    skuStockPlaceholder: 'Please input stock',
    skuStockRequired: 'Please input stock',
    skuId: 'SKU ID',
    skuBarcode: 'Barcode',
    skuBarcodePlaceholder: 'Please input barcode',
    skuStatus: 'SKU status',
    skuStatusOn: 'On shelf',
    skuStatusOff: 'Off shelf',
    deliveryTemplate: 'Delivery template',
    deliveryTemplatePlaceholder: 'Please select delivery template',
    productStatus: 'Product status',
    productStatusOn: 'On',
    productStatusOff: 'Off',
    variantsRequired: 'At least one SKU is required',
    invalidPrice: 'Please input valid SKU price',
    invalidStock: 'Please input valid SKU stock'
  },
  productEdit: {
    pageTitle: 'Edit Product',
    submit: 'Save',
    submitSuccess: 'Product updated successfully',
    submitFailed: 'Failed to update product',
    loadFailed: 'Failed to load product data'
  }
}
